import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.replace("#", "?")).get("session_id");

      // Determine where to redirect after auth
      const path = window.location.pathname;
      const redirectTo = path === "/" ? "/ai-tools/call-analyzer" : path;

      if (!sessionId) {
        navigate(redirectTo, { replace: true });
        return;
      }

      try {
        const res = await axios.post(`${API}/user-auth/session`, {
          session_id: sessionId
        });

        // Store token for authenticated API calls
        if (res.data.session_token) {
          localStorage.setItem("ai_tools_token", res.data.session_token);
        }
        sessionStorage.setItem("user_data", JSON.stringify(res.data));

        navigate(redirectTo, {
          replace: true,
          state: { user: res.data }
        });
      } catch (err) {
        console.error("Auth failed:", err);
        navigate(redirectTo, { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <Loader2 size={40} className="text-[#00F0FF] animate-spin mx-auto mb-4" />
        <p className="text-zinc-400 text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
